var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25678 18.8989C11.3126 18.8989 13.3095 18.213 14.9314 16.9498L21.0501 23.0685C21.5072 23.51 22.2356 23.4973 22.677 23.0402C23.1076 22.5943 23.1076 21.8875 22.677 21.4416L16.5583 15.3229C19.6929 11.2878 18.9629 5.47561 14.9278 2.34099C10.8927 -0.793627 5.08059 -0.0636822 1.94597 3.97142C-1.18865 8.00652 -0.458702 13.8187 3.5764 16.9533C5.2009 18.2153 7.19966 18.8999 9.25678 18.8989ZM4.34043 4.73191C7.05568 2.01661 11.458 2.01656 14.1733 4.73181C16.8886 7.44706 16.8886 11.8494 14.1734 14.5647C11.4581 17.28 7.05583 17.28 4.34053 14.5648C4.34048 14.5647 4.34048 14.5647 4.34043 14.5647C1.62518 11.8692 1.60918 7.48295 4.30465 4.76769C4.31656 4.75573 4.32847 4.74382 4.34043 4.73191Z",
    fill: "#AFAFAF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2706c08c4d912fe330bf96edc59a5151.svg";
export { ForwardRef as ReactComponent };